import { createContext, useContext } from "react"

export const ChangeAssignmentContext = createContext()
const useChangeAssignment = () => useContext(ChangeAssignmentContext)

export default useChangeAssignment